<template>
  <div>
    <validation-errors v-if="showValidationError" :errors="validationErrorMessages" class="mb-1" />
    <submit-button :form-valid="formValid && recaptchaLoaded"
                   :label="label" :submitting-label="submittingLabel"
                   :submit-in-progress="submitInProgress" :class="buttonClass"
                   @click="submit" />
  </div>
</template>

<script>
import SubmitButton from './submit-button'
import ValidationErrors from '@/components/inputs/validation-errors'

export default {
  components: { SubmitButton, ValidationErrors },

  props: {
    // This prop needs to be named `buttonClass` rather than `class` because ESLint will
    // throw a vue/no-parsing-error error if a prop is named `class`.
    buttonClass: {
      type: String,
      required: false
    },

    recaptchaAction: {
      type: String,
      required: true
    },

    formValid: {
      type: Boolean,
      required: false,
      default: true
    },

    label: {
      type: String,
      required: true
    },

    submitInProgress: {
      type: Boolean,
      required: false,
      default: false
    },

    submittingLabel: {
      type: String,
      required: false
    },

    validationErrors: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },

  emits: ['submit-with-token'],

  data() {
    return {
      recaptchaLoaded: false
    }
  },

  computed: {
    showValidationError() {
      return this.validationErrors.recaptchaScore || this.validationErrors.recaptchaVerifyResult
    },

    validationErrorMessages() {
      if (this.validationErrors.recaptchaVerifyResult) {
        return this.validationErrors.recaptchaVerifyResult
      } else {
        return [this.i18n.t('public.bot_protection.rejected', {org_name: this.agraConfiguration.organisationName})]
      }
    }
  },

  created() {
    // Lazy-loading the recaptcha initialization script.
    const { waitForRecaptchaLoaded } = require('../../recaptcha')
    this.waitForRecaptchaLoaded = waitForRecaptchaLoaded
  },

  mounted: async function() {
    await this.waitForRecaptchaLoaded(200)
    this.recaptchaLoaded = true
  },

  methods: {
    waitForToken(action) {
      const siteKey = this.agraConfiguration.botProtection.siteKey
      return new Promise((resolve) => {
        /* eslint-disable-next-line no-undef  */
        grecaptcha.ready(() => {
          /* eslint-disable-next-line no-undef  */
          grecaptcha.execute(siteKey, { action })
            .then((token) => {
              resolve(token)
            })
        })
      })
    },

    submit: async function() {
      const recaptchaToken = await this.waitForToken(this.recaptchaAction)
      this.$emit('submit-with-token', {recaptchaToken})
    }
  }
}
</script>
